<template>
  <VanPopup
    v-model:show="modalStore.showSubscribeModal"
    class="overflow-visible w-full bg-transparent modal-swap-received"
    overlay-class="modal-swap-received-overlay"
    :close-on-click-overlay="false"
  >
    <div class="w-full flex flex-col justify-center items-center">
      <div id="swiper" class="swiper mySwiper w-full max-w-[380px]">
        <div class="swiper-wrapper">
          <div @click.stop v-for="item in list" class="swiper-slide">
            <SubscriptionCard
              :subscription="item"
              v-model:select-yearly="isYearly"
              showYearlySelect
              class="rounded-3xl py-12"
            />
          </div>
        </div>

        <div class="hidden md:block">
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
      <button
        class="btn btn-ghost"
        @click.self="modalStore.showSubscribeModal = false"
      >
        {{ $t(`Buttons.cancel`) }}
      </button>
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { useGlobalModal } from "@/stores/globalModal";
import Swiper from "swiper";
import "swiper/css";
import "swiper/css/effect-cards";
import "swiper/css/navigation";
import "swiper/bundle";
import SubscriptionCard from "@/views/NSFW/Crystal/SubscriptionCard.vue";
import { watch } from "vue";
import { nextTick } from "vue";
import { ref } from "vue";
const modalStore = useGlobalModal();
const list = ref<Subscription[]>([
  ...[1, 2, 3, 4].map((i) => ({
    subscriptionType: i,
    billingFrequency: 2,
  })),
]);
let swiper: Swiper | null = null;
const isYearly = ref(2);

watch(
  () => modalStore.showSubscribeModal,
  (val) => {
    if (val) {
      if (!swiper) {
        nextTick(() => {
          swiper = new Swiper("#swiper", {
            effect: "cards",
            grabCursor: true,
            initialSlide: 2,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });
        });
      } else {
        if (swiper.activeIndex !== 2) swiper.slideTo(2);
      }
    }
  }
);

watch(
  () => isYearly.value,
  (val) => {
    list.value = list.value.map((item) => ({
      ...item,
      billingFrequency: val,
    }));
    nextTick(() => {
      swiper?.update();
      swiper?.slideTo(2);
    });
  }
);

// onMounted(() => {
//   swiper = new Swiper("#swiper", {
//     effect: "cards",
//     grabCursor: true,
//     initialSlide: 2,
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//   });
// });
</script>

<style scoped>
.modal-swap-received {
  background: transparent;
}

.modal-swap-received-overlay {
  background-color: rgba(0, 0, 0, 0.5);
  /* 高斯模糊 */
  backdrop-filter: blur(10px);
}

:deep(.swiper-slide-shadow) {
  border-radius: 1.5rem;
}

.swiper-button-prev,
.swiper-button-next {
  width: 50px;
  height: 50px;
  background: rgb(229 45 39 / var(--tw-bg-opacity));
  color: #fff;
  border-radius: 50%;
}

.swiper-button-prev {
  left: -100px;
}

.swiper-button-next {
  right: -100px;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 24px;
  font-weight: 900;
}

.swiper-button-prev:after {
  margin-right: 5px;
}

.swiper-button-next:after {
  margin-left: 5px;
}
</style>
